<template>
  <div style="padding:5px 0">
    <div class="section operations">
      <div class="triggers">
        <div>
          <el-button no="new" :disabled="!isEditing" type="primary" @click="showEditDialog(1)">{{ $t('common.btn.new') }}</el-button>
          <el-button no="edit" :disabled="!(isEditing && selectedRow)" type="primary" @click="showEditDialog(2)">{{ $t('common.btn.edit') }}</el-button>
          <el-button v-show="$checkPermission(['button_TabCustomerEvent_delete'])" no="delete" :disabled="!isEditing" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="101410"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="finalRowData"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-if="editDialog.visible"
      id="editDialog"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_EventRecord')"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_theme')" required>
            <el-select
              v-model="editDialog.form.titleName"
              no="titleName"
              style="width: 100%"
              :disabled="!editDialog.isEdit"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_SUBJECTS"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaskTime')">
            <el-date-picker
              v-model="editDialog.form.taskTime"
              no="taskTime"
              style="width: 100%"
              type="datetime"
              :clearable="false"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd HH:mm"
              :disabled="!(editDialog.isEdit && editDialog.isEditTime)"
              :editable="false"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Recorder')">
            <el-input v-model="editDialog.form.recorderName" no="recorderName" :disabled="true" style="width: 100%" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_RecordTime')">
            <el-date-picker
              v-model="editDialog.form.recordTime"
              no="recordTime"
              type="datetime"
              style="width: 100%"
              format="yyyy-MM-dd HH:mm"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EventStatus')" required>
            <el-select
              v-model="editDialog.form.status"
              no="status"
              style="width: 100%"
              :disabled="!editDialog.isEdit"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_STATUSS"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Location')">
            <el-input v-model="editDialog.form.address" no="address" :disabled="!editDialog.isEdit" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Participant')">
            <el-input v-model="editDialog.form.participants" no="participants" type="textarea" :rows="3" :disabled="!editDialog.isEdit" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ContentDescription')">
            <el-input v-model="editDialog.form.content" no="content" type="textarea" :rows="9" :disabled="!editDialog.isEdit" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Outcomes')">
            <el-input v-model="editDialog.form.achievement" no="achievement" type="textarea" :rows="3" :disabled="!editDialog.isEdit" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NextStep')">
            <el-input v-model="editDialog.form.nextTask" no="nextTask" type="textarea" :rows="3" :disabled="!editDialog.isEdit" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ReportTo')">
            <el-input v-model="editDialog.form.reportTarget" no="reportTarget" type="textarea" :rows="2" :disabled="!editDialog.isEdit" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" type="textarea" :rows="3" :disabled="!editDialog.isEdit" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="editDialog.isEdit" no="save" type="primary" @click="save">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="close" @click="close">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { loadCompanyRelated } from '@/api/company'

export default {
  name: 'TabCustomerEvent',
  components: {
  },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      CrmCustomerConstants,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        onRowDoubleClicked: event => { this.onRowDoubleClicked() }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 35,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EventTime'),
          colId: 'taskTime',
          field: 'taskTime',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Recorder'),
          colId: 'recorderId',
          field: 'recorderId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Location'),
          colId: 'address',
          field: 'address',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Participant'),
          colId: 'participants',
          field: 'participants',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_theme'),
          colId: 'titleName',
          field: 'titleName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContentDescription'),
          colId: 'content',
          field: 'content',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RecordTime'),
          colId: 'recordTime',
          field: 'recordTime',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          colId: 'remarks',
          field: 'remarks',
          width: 150
        }
      ],
      gridApi: null,
      rowData: [],
      selectedRow: null, // 当前选中行
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      editDialog: {
        isEditTime: false, // 是否可以编辑时间
        isEdit: false, // 是否编辑状态
        visible: false,
        form: {},
        initialForm: {
          uuid: '',
          taskTime: '',
          recorderId: 0,
          recorderName: '',
          address: '',
          participants: '',
          titleName: '',
          status: '',
          content: '',
          recordTime: '',
          remarks: '',
          quotationClientUuid: ''
        }
      },
      form: {
        uuid: ''
      }
    }
  },
  computed: {
    isEditing() {
      return this.action === 'edit'
    },
    readOnly() {
      return this.action === 'look'
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  created() {
    this.editDialog.form = { ...this.editDialog.initialForm }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh && this.isEditing) return
      this.form = row
      if (this.readOnly) {
        const data = await loadCompanyRelated({ companyUuid: this.form.uuid, events: true }).then(res => res.data)
        this.form.events = data ? data.events : row.events
      }
      this.rowData = this.form.events || []
    },
    // 保存
    getSubmitData() {
      return {
        company: this.form,
        eventList: this.rowData
      }
    },
    // 行点击
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    onRowDoubleClicked() {
      this.showEditDialog(this.isEditing ? 2 : 0)
    },
    // 新增 1 /编辑 2/查看 0
    showEditDialog(state) {
      this.editDialog.isEdit = (state !== 0)
      if (state === 1) {
        this.editDialog.isEditTime = true
        this.editDialog.form = { ...this.editDialog.initialForm }
        this.editDialog.form.recorderId = this.$store.getters.userId
        this.editDialog.form.recordTime = new Date()
        this.editDialog.form.taskTime = new Date()
      } else {
        if (!this.gridApi) return
        // 编辑 查看 走这里
        if (!this.selectedRow) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PSAEF'))
          return
        }
        this.editDialog.isEditTime = false
        this.editDialog.form = this.selectedRow
      }
      const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(this.editDialog.form.recorderId))
      this.editDialog.form.recorderName = this.$store.getters.language === 'zh' ? user.chineseName : user.englishName
      this.editDialog.visible = true
    },
    // 确认保存/修改
    save() {
      if (!this.editDialog.form.titleName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectSubject'))
        return
      }
      if (!this.editDialog.form.status) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectEventStatus'))
        return
      }

      // 处理新增
      if (!this.editDialog.form.uuid) {
        const index = this.rowData.indexOf(this.editDialog.form)
        if (index < 0) this.rowData.push(this.editDialog.form)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        }, 100)
      } else {
        // 处理编辑
        if (this.rowData && this.rowData.length > 0) {
          for (const contact of this.rowData) {
            if (contact.uuid === this.editDialog.form.uuid) {
              Object.assign(contact, this.editDialog.form)
              contact.updated = true // updated 是否需要更新标识
              break
            }
          }
        }
      }
      this.close()
      this.gridApi.refreshCells({ force: true })
    },
    // 取消
    close() {
      this.editDialog.visible = false
    },
    // 删除【只删除界面值】
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const row of rows) {
        if (row.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
          row.deleted = true // deleted 是否需要更新标识
        } else {
          const index = this.rowData.findIndex(p => p === row)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
      setTimeout(() => {
        this.gridApi.setFocusedCell(0)
        this.selectedRow = null
        if (this.finalRowData && this.finalRowData.length > 0) {
          this.selectedRow = this.finalRowData[0]
        }
      }, 100)
      this.gridApi.refreshCells({ force: true })
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      return currDate < new Date()
    }
  }
}
</script>
<style scoped lang="scss">
</style>
